(function () {
  const slider = document.getElementById('before-after-slider')
  const before = document.getElementById('before-image')
  const beforeImage = before && before.getElementsByTagName('img')[0]
  const resizer = document.getElementById('resizer')

  if (!slider || !before || !beforeImage || !resizer) return

  let active = false

  // Sort overflow out for Overlay Image
  document.addEventListener('DOMContentLoaded', () => {
    const width = 2000
    beforeImage.style.width = `${width}px`
  })

  // Adjust width of image on resize
  window.addEventListener('resize', () => {
    const width = 2000
    beforeImage.style.width = `${width}px`
  })

  resizer.addEventListener('mousedown', () => {
    active = true
    resizer.classList.add('resize')
  })

  document.body.addEventListener('mouseup', () => {
    active = false
    resizer.classList.remove('resize')
  })

  document.body.addEventListener('mouseleave', () => {
    active = false
    resizer.classList.remove('resize')
  })

  document.body.addEventListener('mousemove', (e) => {
    if (!active) return
    let x = e.pageX
    x -= slider.getBoundingClientRect().left
    slideIt(x)
    pauseEvent(e)
  })

  resizer.addEventListener('touchstart', () => {
    active = true
    resizer.classList.add('resize')
  })

  document.body.addEventListener('touchend', () => {
    active = false
    resizer.classList.remove('resize')
  })

  document.body.addEventListener('touchcancel', () => {
    active = false
    resizer.classList.remove('resize')
  })

  // calculation for dragging on touch devices
  document.body.addEventListener('touchmove', (e) => {
    if (!active) return
    let x

    let i
    for (i = 0; i < e.changedTouches.length; i++) {
      x = e.changedTouches[i].pageX
    }

    x -= slider.getBoundingClientRect().left
    slideIt(x)
    pauseEvent(e)
  })

  function slideIt (x) {
    const transform = Math.max(0, (Math.min(x, slider.offsetWidth)))
    before.style.width = `${transform}px`
    resizer.style.left = `${transform - 0}px`
  }

  // stop divs being selected.
  function pauseEvent (e) {
    if (e.stopPropagation) e.stopPropagation()
    if (e.preventDefault) e.preventDefault()
    e.cancelBubble = true
    e.returnValue = false
    return false
  }
})()
